'use client'

import Link from 'next/link'
import { PiShoppingCartSimpleDuotone } from 'react-icons/pi'
import { Badge } from '../ui'
import { useCartStore } from '@/store/useCartStore'

const CartButton = () => {
    const { countItems } = useCartStore()
    return (
        <Link
            href="/cart"
            className="cursor-pointer flex items-center hover:text-gray-600 transition-colors"
        >
            <div className="relative">
                <div className="bg-gray-200 hover:bg-gray-300 rounded-full w-[48px] h-[48px] flex justify-center items-center">
                    <PiShoppingCartSimpleDuotone size={24} />
                </div>

                {(countItems ?? 0) > 0 && (
                    <Badge
                        content={countItems}
                        innerClass="!bg-error"
                        className="absolute -top-1 -right-1"
                    />
                )}
            </div>
        </Link>
    )
}

export default CartButton
